export default "__VITE_ASSET__CW7C_35l__"